import {EntityWithAuditMetadata} from "../../../../common/entity/entityWithAuditMetadata";
import {SummaryModel} from "../../../../common/entity/summary.model";
import {ProviderSummaryModel} from "../../../../provider/common/api/entity/providerSummary.model";

export class InsolesProfileSummaryModel extends EntityWithAuditMetadata implements SummaryModel {
    id: number;
    name: string;
    active: boolean;
    provider: ProviderSummaryModel;
    byDefault: boolean;
}